// Third-party
import React from 'react';
import classNames from 'classnames';

// Components
import { NoDataCell } from '../../cells';

// Utils
import Locale from '@/types/locale';
import { LoadingSpinner } from '../../common';
import PlanningAssetAllocationValue from '@/types/planning-asset-allocation-value';
import PlanningRiskProfileCompare from '../../modals/portfolio-editor-builder/components/PlanningRiskProfileCompare';

type Props = {
  value?: PlanningAssetAllocationValue;
  className?: string;
  showBaseCurrencies?: boolean;
  locale?: Locale;
  decimalPlace?: number;
};

const PlanningAssetAllocationCell: React.FunctionComponent<Props> = ({ value, className, locale }: Props) => {
  if (value == null || !value.planAccountId) {
    return <NoDataCell />;
  }

  const { planAccount, comparisonItem, user } = value;

  return (
    <div className={classNames('cell planning-asset-allocation-cell', className)}>
      {!planAccount && <LoadingSpinner />}

      {planAccount && (
        <PlanningRiskProfileCompare
          comparisonItem={comparisonItem}
          account={planAccount}
          user={user}
          locale={locale}
          hideConfig={{ hideRuleLabel: true, hideBars: false, hideTable: true }}
        />
      )}
    </div>
  );
};

export default PlanningAssetAllocationCell;
